import { render, staticRenderFns } from "./StudentLessonText.vue?vue&type=template&id=60e21a86&scoped=true&"
import script from "./StudentLessonText.vue?vue&type=script&lang=js&"
export * from "./StudentLessonText.vue?vue&type=script&lang=js&"
import style0 from "./StudentLessonText.vue?vue&type=style&index=0&id=60e21a86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e21a86",
  null
  
)

export default component.exports